<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Documentos relacionados:
    </h4>
    <hr>

    <div class="form-group row">

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Documentos relacionados (PDF)</label>
            <div class="label-container">
                <div class="row align-items-center">
                    <div class="col-md-12" style="margin-top: 20px;">
                        <div class="input-group">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                    (click)="fileInput.click()">
                                    Cargar PDF
                                </button>
                            </div>
                            <input type="text" disabled class="form-control" placeholder="PDF" formControlName="doc">
                        </div>
                        <input #fileInput class="form-file" type="file" id="input-file-pdf"
                            (change)="onPdfChange($event)" accept=".pdf" multiple style="display: none;">
                    </div>
                    <div class="col-md-12" style="margin-top: 20px;">
                        <ul class="pdf-list">
                            <li *ngFor="let pdfName of tempfilenamePDF; let i = index">
                                <div class="pdf-item">
                                    <span>{{i+1}}.</span> <input type="text" class="pdf-name" [value]="pdfName"
                                        (blur)="updatetempfilenamePDF(i, $event.target.value)">
                                    <button type="button" class="pdf-delete-button" (click)="removePdf(i)">x</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>